import React, { useEffect } from "react";

const BlogLayout = () => {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={styles.page}>
      {/* ===== Banner Section ===== */}
      <div style={styles.bannerSection}>
        <div style={styles.bannerOverlay}></div>
        <div style={styles.bannerContent}>
          <h1 style={styles.bannerTitle} className="slide-in">
            Intelligent Industrial Automation
          </h1>
          <p style={styles.bannerText} className="slide-in">
            Driving Smart Manufacturing with AI, IoT, and Robotics
          </p>
        </div>
      </div>

      {/* ===== Blog Container ===== */}
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>
            Intelligent Industrial Automation: Transforming the Future of Manufacturing
          </h1>

          {/* Author & Meta */}
          <div style={styles.meta}>
            <img
              src="/images/author.jpg"
              alt="Author"
              style={styles.authorImage}
            />
            <div>
              <p style={styles.author}>By John Miller</p>
              <p style={styles.details}>
                <i className="far fa-calendar-alt" style={styles.iconInline}></i>{" "}
                23 Aug 2025 &nbsp; | &nbsp;
                <i className="far fa-clock" style={styles.iconInline}></i> 8 min
                read &nbsp; | &nbsp;
                <i className="far fa-eye" style={styles.iconInline}></i> 1,240
                Views
              </p>
            </div>
          </div>

          {/* Blog Intro */}
          <p style={styles.text}>
            <i className="fas fa-industry" style={styles.iconInline}></i>
            Intelligent Industrial Automation (IIA) integrates advanced
            technologies such as Artificial Intelligence (AI), Internet of
            Things (IoT), Big Data, and Robotics to create smart factories.
            Unlike traditional automation, IIA focuses on real-time decision
            making, predictive maintenance, and adaptive manufacturing.
          </p>
          <p style={styles.text}>
            <i className="fas fa-robot" style={styles.iconInline}></i>
            From self-optimizing production lines to AI-powered quality control,
            intelligent automation ensures higher efficiency, reduced downtime,
            and improved product quality.
          </p>

          {/* Why It Matters */}
          <h2 style={styles.subheading}>Why Intelligent Industrial Automation Matters</h2>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-chart-line" style={styles.iconList}></i> Boosts productivity and operational efficiency
            </li>
            <li>
              <i className="fas fa-shield-alt" style={styles.iconList}></i>{" "}
              Improves workplace safety with smart monitoring
            </li>
            <li>
              <i className="fas fa-cogs" style={styles.iconList}></i> Enables predictive maintenance to reduce downtime
            </li>
            <li>
              <i className="fas fa-recycle" style={styles.iconList}></i> Supports sustainability with energy optimization
            </li>
          </ul>

          {/* Key Technologies */}
          <h2 style={styles.subheading}>Key Technologies Driving IIA</h2>
          <p style={styles.text}>
            Intelligent Automation in industries is made possible through a
            powerful combination of technologies:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-brain" style={styles.iconList}></i>{" "}
              Artificial Intelligence for real-time decision making
            </li>
            <li>
              <i className="fas fa-network-wired" style={styles.iconList}></i>{" "}
              Industrial IoT for connected devices and sensors
            </li>
            <li>
              <i className="fas fa-database" style={styles.iconList}></i> Big Data
              analytics for predictive insights
            </li>
            <li>
              <i className="fas fa-robot" style={styles.iconList}></i> Robotics and
              Cobots for smart manufacturing
            </li>
          </ul>

          {/* Example */}
          <h2 style={styles.subheading}>Example: Smart Factory Implementation</h2>
          <p style={styles.text}>
            <i className="fas fa-industry" style={styles.iconInline}></i>
            Automotive manufacturers use intelligent automation to monitor
            assembly lines in real-time. AI-powered cameras detect defects
            instantly, while IoT sensors track machine performance. Predictive
            algorithms alert technicians before equipment failure, ensuring
            uninterrupted production.
          </p>

          {/* Best Practices */}
          <h2 style={styles.subheading}>Best Practices for Implementing IIA</h2>
          <p style={styles.text}>
            <i className="fas fa-lightbulb" style={styles.iconInline}></i>
            For businesses looking to adopt Intelligent Industrial Automation,
            these practices ensure long-term success:
          </p>
          <ul style={styles.list}>
            <li>
              <i className="fas fa-layer-group" style={styles.iconList}></i> Start
              with scalable pilot projects
            </li>
            <li>
              <i className="fas fa-cloud" style={styles.iconList}></i> Leverage
              cloud platforms for data storage and analysis
            </li>
            <li>
              <i className="fas fa-user-shield" style={styles.iconList}></i>{" "}
              Ensure cybersecurity in connected systems
            </li>
            <li>
              <i className="fas fa-users" style={styles.iconList}></i> Train
              workforce for human-machine collaboration
            </li>
          </ul>

          {/* Future */}
          <h2 style={styles.subheading}>The Future of Intelligent Automation</h2>
          <p style={styles.text}>
            <i className="fas fa-rocket" style={styles.iconInline}></i>
            The future of manufacturing lies in hyper-connected, AI-driven smart
            factories. With advancements in 5G, edge computing, and autonomous
            robotics, industries will move towards zero-defect production,
            sustainable operations, and fully adaptive supply chains.
          </p>

          {/* Conclusion */}
          <h2 style={styles.subheading}>Conclusion</h2>
          <p style={styles.text}>
            <i className="fas fa-check-circle" style={styles.iconInline}></i>
            Intelligent Industrial Automation is revolutionizing the way
            industries operate. Companies adopting smart automation are gaining
            a competitive edge through higher efficiency, cost reduction, and
            improved product innovation. The shift to intelligent systems is not
            just an upgrade—it’s the future of industrial growth.
          </p>
        </div>
      </div>

      {/* ===== Animation CSS ===== */}
      <style>
        {`
          @keyframes slideIn {
            0% {
              opacity: 0;
              transform: translateX(-40px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
          .slide-in {
            animation: slideIn 1.2s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  page: {
    position: "relative",
    background: "#fff",
    fontFamily: "Arial, sans-serif",
    letterSpacing: "0px",
  },
  /* ===== Banner Styles ===== */
  bannerSection: {
    position: "relative",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/shutterstock_2495047313-1.webp')", 
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0 10%",
    color: "#fff",
  },
  bannerOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  bannerContent: {
    position: "relative",
    zIndex: 2,
    maxWidth: "600px",
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
    color:"white",
  },
  bannerText: {
    fontSize: "18px",
    lineHeight: "1.6",
    maxWidth: "500px",
    textAlign:"justify",
  },

  /* ===== Blog Styles ===== */
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    maxWidth: "900px",
    margin: "auto",
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
    lineHeight: "1.3",
    letterSpacing:"0px",
  },
  meta: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
    gap: "12px",
  },
  authorImage: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  author: {
    margin: 0,
    fontWeight: "bold",
    fontSize: "15px",
  },
  details: {
    margin: 0,
    fontSize: "14px",
    color: "#666",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#333",
    marginBottom: "15px",
    textAlign: "justify",
  },
  subheading: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
    marginBottom: "12px",
    letterSpacing:"0px",
  },
  list: {
    paddingLeft: "0px",
    marginBottom: "20px",
    listStyle: "none",
  },
  iconList: {
    marginRight: "8px",
    color: "#007bff",
  },
  iconInline: {
    marginRight: "6px",
    color: "#007bff",
  },

  /* ===== Responsive ===== */
  "@media (max-width: 768px)": {
    bannerTitle: {
      fontSize: "28px",
    },
    bannerText: {
      fontSize: "16px",
    },
    title: {
      fontSize: "26px",
    },
  },
};

export default BlogLayout;
